<template>
    <div class="landing">
        <el-row>
            <div class="landing-header-container">
                <Ticker :slides="slides" />
                <Header class="landing-header">
                    <div class="landing-header-left" v-if="!isMobile()">
                        <div class="landing-header-title">
                            Chicago Athenaeum Museum of Architecture and Design
                        </div>
                        <div class="landing-header-title">
                            European Centre for Architecture Art Design and
                            Urban Studies
                        </div>
                    </div>
                    <div class="landing-header-middle">
                        <div class="landing-header-title">
                            TCA - ECADUS <br />
                            AWARDS SUBMISSION PAGE
                        </div>
                    </div>
                    <!--<div class="landing-header-right">
                        <div></div>
                    </div>-->
                </Header>
            </div>
        </el-row>
        <el-row>
            <Slider :slides="slides" />
            <div class="landing-tutorial">
                <img class="arrow-image" src="/images/arrow.png" />
                <div>
                    Welcome to The Chicago Athenaeum and The European Centre
                    Submission page. <BR />
                    Download the New Application Guide for Submission
                    Instructions
                    <a
                        target="_blank"
                        href="https://awardapplication.com/pdf/TCA-FORMS-INSRUCTIONS.pdf"
                        >here</a
                    >
                </div>
            </div>
            <Grid />
        </el-row>
        <el-row>
            <footer>
                <!-- Footer main -->
                <section class="ft-main">
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Awards Organizers</h2>
                        <ul>
                            <li>
                                <a
                                    href="https://www.chi-athenaeum.org/"
                                    target="_blank"
                                    >The Chicago Athenaeum</a
                                >
                            </li>
                            <li>
                                <a
                                    href="http://europeanarch.eu/"
                                    target="_blank"
                                    >The European Centre</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Legal</h2>
                        <ul>
                            <li>
                                <router-link
                                    :to="{
                                        name: 'terms-and-conditions',
                                    }"
                                    target="_blank"
                                >
                                    Terms & Conditions
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{
                                        name: 'refund-policy',
                                    }"
                                    target="_blank"
                                >
                                    Refund Policy
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Connect</h2>
                        <ul>
                            <li>
                                <a
                                    href="https://www.instagram.com/thechicagoathenaeummuseum/"
                                    target="_blank"
                                    >Instagram</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm"
                                    target="_blank"
                                    >Facebook</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.youtube.com/@thechicagoathenaeummuseum"
                                    target="_blank"
                                    >Youtube</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Contact</h2>
                        <ul>
                            <li>
                                <a href="#">curatorial@chi-athenaeum.org</a>
                            </li>
                            <li>
                                <a href="#"
                                    >tel: +1 815 777 4444 (extension 3000)</a
                                >
                            </li>
                        </ul>
                    </div>
                </section>
                <!-- Footer legal -->
                <section class="ft-legal">
                    &copy; 2024 - 2026 All rights reserved for The Chicago
                    Athenaeum Museum of Architecture and Design , European
                    centre for Architecture Art Design and Urban Studies,
                    Metropolitan Arts Press Ltd.
                </section>
            </footer>
        </el-row>
    </div>
</template>

<script>
import axios from "axios";
import Footer from "@/core/components/Footer";
import Slider from "@/core/components/Slider.vue";
import Ticker from "@/core/components/Ticker.vue";
import Grid from "./Grid.vue";

export default {
    components: {
        Grid,
        Slider,
        Ticker,
        Footer,
    },
    data() {
        return {
            slides: [],
        };
    },
    created() {
        this.loadSlides();
    },
    methods: {
        async loadSlides() {
            try {
                const res = await axios.get("slideshow");
                this.slides = res.data.slides;
            } catch (e) {
                console.error("Failed to load slideshow data", e);
            }
        },
        isMobile() {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>
<style>
ul {
    list-style: none;
    padding-left: 0;
}
footer {
    line-height: 1.5;
}
footer a {
    text-decoration: none;
}
a {
    color: #000000;
}
a:hover {
    text-decoration: underline;
}
.ft-title {
    font-weight: bold;
    font-size: 16px;
}
body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}
.container {
    flex: 1;
}
.ft-main {
    padding: 1.25rem 1.875rem;
    display: flex;
    flex-wrap: wrap;
}
@media only screen and (min-width: 29.8125rem /* 477px */) {
    .ft-main {
        justify-content: space-evenly;
    }
}
@media only screen and (min-width: 77.5rem /* 1240px */) {
    .ft-main {
        justify-content: space-evenly;
    }
}
.ft-main-item {
    padding: 1.25rem;
    min-width: 12.5rem;
    .line {
        width: 100%;
        border: 1px solid #000;
        margin: 3px;
        display: inline-block;
    }
}
.ft-legal {
    display: flex;
    justify-content: center;
    align-items: center;
}
.landing-tutorial {
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 16px;
    width: 100%;
    justify-content: center;
    margin-top: 30pt;
    a {
        text-decoration: underline;
    }
    img {
        display: none;
    }
    @media (max-resolution: 1dppx) {
        font-size: 30px;
        text-align: left;
        img {
            width: 110px;
            height: 85px;
            display: inline;
        }
    }
}
</style>
